import { Shield, Clock, Award, HeadphonesIcon } from "lucide-react";

const badges = [
  {
    icon: Shield,
    title: "SSL Secured",
    description: "256-bit encryption",
  },
  {
    icon: Clock,
    title: "99.99% Uptime",
    description: "Guaranteed SLA",
  },
  {
    icon: Award,
    title: "Award Winning",
    description: "Top rated support",
  },
  {
    icon: HeadphonesIcon,
    title: "24/7 Support",
    description: "Always available",
  },
];

const TrustBadgesSection = () => {
  return (
    <section className="py-16 bg-background">
      <div className="container-custom">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {badges.map((badge, index) => (
            <div
              key={badge.title}
              className="flex flex-col items-center text-center p-6 rounded-xl bg-muted/50 animate-fade-in-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="w-14 h-14 gradient-primary rounded-xl flex items-center justify-center mb-4">
                <badge.icon className="w-7 h-7 text-primary-foreground" />
              </div>
              <h3 className="font-semibold text-foreground mb-1">{badge.title}</h3>
              <p className="text-sm text-muted-foreground">{badge.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadgesSection;
